// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid{display:grid;grid-template-columns:repeat(1,1fr);grid-template-rows:repeat(3,1fr);grid-gap:1.5rem;gap:1.5rem}@media screen and (min-width:48em){.grid{grid-template-columns:repeat(3,1fr);grid-template-rows:unset}}@media screen and (min-width:64em){.grid{grid-gap:2rem;gap:2rem;padding-top:6rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
